'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tab = function Tab(_ref) {
  var action = _ref.action,
      icon = _ref.icon,
      selected = _ref.selected,
      small = _ref.small,
      title = _ref.title;

  var newAction = selected ? null : action;
  var type = selected ? 'primary' : 'secondary';
  var newIcon = icon || null;
  return _react2.default.createElement(_Button2.default, { className: 'Tab', action: newAction, iconLeft: newIcon, title: title, small: small, type: type });
};

Tab.propTypes = {
  /** Action triggered when the tab item is clicked. */
  action: _propTypes2.default.func,
  /** The name of the icon to display on the left side of the tab item. */
  icon: _propTypes2.default.string,
  /** Whether the tab item is selected. */
  selected: _propTypes2.default.bool,
  /** Whether the tab has smaller text. */
  small: _propTypes2.default.bool,
  /** The title of the tab item. */
  title: _propTypes2.default.string.isRequired
};

Tab.defaultProps = {
  action: null,
  icon: null,
  selected: false,
  small: false
};

exports.default = Tab;
Tab.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'Tab',
  'props': {
    'action': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Action triggered when the tab item is clicked.'
    },
    'icon': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'The name of the icon to display on the left side of the tab item.'
    },
    'selected': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether the tab item is selected.'
    },
    'small': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether the tab has smaller text.'
    },
    'title': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'The title of the tab item.'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/Tab.js
// module id = 277
// module chunks = 0